<template>
  <div class="page-container">
    <h1 class="page-title">{{ t("pages.products.service.title") }}</h1>
    <div class="content-section">
      <div
        class="text-block"
        v-html="renderContent(t('pages.products.service.introduction.content'))"
      ></div>
    </div>
    <div class="decorative-divider"></div>
      
    <!-- 应用案例部分 -->
    <div class="content-section">
      <div class="section-header">
        <h2 class="section-title">
          {{ t("pages.products.service.introduction.cases[0].title") }}
        </h2>
      </div>
      <div
        class="text-block"
        v-html="renderContent(t('pages.products.service.introduction.cases[0].content'))"
      ></div>
      <div style="text-align: center;">
        <img src="/images/products/小批量高性能超导带材.png" />
      </div>
      <p>{{ t("pages.products.service.introduction.cases[0].pcontent") }}</p>

    </div>
    <div class="decorative-divider"></div>

    <div class="content-section">
      <div class="section-header">
        <h2 class="section-title">
          {{ t("pages.products.service.introduction.cases[1].title") }}
        </h2>
      </div>
      <div
        class="text-block"
        v-html="renderContent(t('pages.products.service.introduction.cases[1].content'))"
      ></div>
      <div style="text-align: center;">
        <img src="/images/products/小批量激光分切超导带材.png" />
      </div>
    </div>
    <div class="decorative-divider"></div>

    <div class="content-section">
      <div class="section-header">
        <h2 class="section-title">
          {{ t("pages.products.service.introduction.cases[2].title") }}
        </h2>
      </div>
      <div
        class="text-block"
        v-html="renderContent(t('pages.products.service.introduction.cases[2].content'))"
      ></div>
      <div style="text-align: center;">
        <img src="/images/products/小批量铜银合金封装超导带材.png" />
      </div>
    </div>
    <div class="decorative-divider"></div>
  </div>
</template>

<script setup lang="ts">
import { ref, computed } from "vue";
import { useI18n } from "vue-i18n";


const { t } = useI18n();

// 渲染带有换行的内容
const renderContent = (content: string) => {
  if (!content) return "";
  return content
    .split("\n\n")
    .map((paragraph) => `<p>${paragraph}</p>`)
    .join("");
};
</script>

<style scoped>
@import "@/assets/styles/content-blocks.scss";
.page-container {

  max-width: 1200px;
  margin: 0 auto;
}

@media screen and (max-width: 768px) {
  .page-container {
    padding: 30px 15px;
  }
}
.page-container {
  overflow: auto;
}
</style> 